import { fromJcamp } from 'nmr-metadata';
import { getBasename, getExtension, getFilename, getTargetProperty, getTextContent, } from "../common.js";
const isFid = /[^a-z]fid[^a-z]/i;
const replaceFid = /[^a-z]fid[^a-z]?/i;
const nmr = {
    find: (entries, filename) => {
        const reference = getReference(filename);
        return entries.find((entry) => {
            return getReference(getFilename(entry) ?? '') === reference;
        });
    },
    getProperty: (filename) => {
        const extension = getExtension(filename);
        if ((extension === 'jdx' || extension === 'dx' || extension === 'jcamp') &&
            isFid.test(filename)) {
            return 'jcampFID';
        }
        return getTargetProperty(filename);
    },
    process: (filename, content) => {
        const extension = getExtension(filename);
        let metaData = {};
        if (extension === 'jdx' || extension === 'dx' || extension === 'jcamp') {
            const textContent = getTextContent(content);
            metaData = fromJcamp(textContent);
        }
        return metaData;
    },
    jpath: ['spectra', 'nmr'],
};
export default nmr;
const reg2 = /(?<name>.*)\.(?<ext>.*)/;
function getReference(filename) {
    if (filename === undefined)
        return undefined;
    let reference = getBasename(filename);
    reference = reference.replace(reg2, '$1');
    if (isFid.test(filename)) {
        reference = reference.replace(replaceFid, '');
    }
    return reference;
}
//# sourceMappingURL=nmr.js.map